__turbopack_context__.v({
  "DownloadAdventureDiv2": "DownloadApp-module__TVOGna__DownloadAdventureDiv2",
  "DownloadAdventureFlags": "DownloadApp-module__TVOGna__DownloadAdventureFlags",
  "faqSection": "DownloadApp-module__TVOGna__faqSection",
  "heroCopy": "DownloadApp-module__TVOGna__heroCopy",
  "heroDesc": "DownloadApp-module__TVOGna__heroDesc",
  "heroGrid": "DownloadApp-module__TVOGna__heroGrid",
  "heroTitle": "DownloadApp-module__TVOGna__heroTitle",
  "qrCard": "DownloadApp-module__TVOGna__qrCard",
  "qrImage": "DownloadApp-module__TVOGna__qrImage",
  "qrLabel": "DownloadApp-module__TVOGna__qrLabel",
  "storeCard": "DownloadApp-module__TVOGna__storeCard",
  "storeCardBody": "DownloadApp-module__TVOGna__storeCardBody",
  "storeCardLabel": "DownloadApp-module__TVOGna__storeCardLabel",
  "storeCardName": "DownloadApp-module__TVOGna__storeCardName",
  "storeCards": "DownloadApp-module__TVOGna__storeCards",
  "storeLogo": "DownloadApp-module__TVOGna__storeLogo",
  "storeRating": "DownloadApp-module__TVOGna__storeRating",
  "storeRatingStars": "DownloadApp-module__TVOGna__storeRatingStars",
  "storeRatingValue": "DownloadApp-module__TVOGna__storeRatingValue",
  "videoCard": "DownloadApp-module__TVOGna__videoCard",
  "videoLogo": "DownloadApp-module__TVOGna__videoLogo",
  "videoOverlay": "DownloadApp-module__TVOGna__videoOverlay",
  "videoPlayBtn": "DownloadApp-module__TVOGna__videoPlayBtn",
});
